// water column (wc / inWC) values are always displayed to this many decimals
export const WATER_COLUMN_DECIMALS = 4

// true for any spelling of inches of water column the app uses as a unit
// label ('wc', ' wc', 'inWC')
export const isWaterColumn = units =>
  typeof units === 'string' && /^(in)?\s*wc$/i.test(units.trim())

// decimals to display a pressure in the given units, falling back to
// `defaultDecimals` for anything other than water column
export const getPressureDecimals = (units, defaultDecimals = 3) =>
  isWaterColumn(units) ? WATER_COLUMN_DECIMALS : defaultDecimals

// a pressure value as a string with its units' display precision. Values that
// aren't numbers, or units with a null `defaultDecimals`, are returned
// unchanged.
export const formatPressureValue = (value, units, defaultDecimals = 3) => {
  const num = parseFloat(value)
  const decimals = getPressureDecimals(units, defaultDecimals)
  if (value === null || value === undefined || isNaN(num) || decimals == null) {
    return value
  }

  return num.toFixed(decimals)
}
